export default {
    SET_SHOW: 'SET_SHOW',
}


// WEBPACK FOOTER //
// ./src/_store/modules/tabBar/mutation-enum.js